import classNames from 'classnames'
import { useMemo } from 'react'

// Utility function to allow external class names for components with className set at the root level.
export function useExternalClassName({ external, local }: { external: string | undefined; local: string }) {
  return useMemo(() => classNames(external ? [local, external] : [local]), [external, local])
}
